import _stripTags from "../quill/stripTags.js";
const stripTags = _stripTags;
export default (function removeTextlessEvents(eventGroup) {
  eventGroup.events = eventGroup.events.filter(event => {
    return stripTags(event.text).trim() !== "";
  });
  return eventGroup;
});